const createSvgElement = (name, props = {}) => {
  const element = window.document.createElementNS(
    "http://www.w3.org/2000/svg",
    name
  );
  Object.entries(props).forEach(
    ([key, value]) => element.setAttribute(key, value)
  );
  return element;
};
const getJoinedTspanText = (textElement) => Array.from(textElement.childNodes).filter((node) => node.nodeName === "tspan").map((tspan) => {
  var _a;
  return (_a = tspan == null ? void 0 : tspan.textContent) == null ? void 0 : _a.trim();
}).join(" ");
class TextMeasurer {
  constructor() {
    this.ctx_ = typeof window === "undefined" ? {} : document.createElement("canvas").getContext("2d");
  }
}
class MeasureText extends TextMeasurer {
  constructor(fontSize, fontFamily) {
    super();
    this.getTextWidth = (text) => this.ctx_.measureText(text).width;
    this.ctx_.font = `${fontSize} ${fontFamily}`;
  }
}
const FONT_STYLE_REPLACEMENT_TOKEN = "FONT_STYLE";
const FONT_WEIGHT_REPLACEMENT_TOKEN = "FONT_WEIGHT";
const FONT_SIZE_REPLACEMENT_TOKEN = "FONT_SIZE";
const LINE_HEIGHT_REPLACEMENT_TOKEN = "LINE_HEIGHT";
const FONT_FAMILY_REPLACEMENT_TOKEN = "FONT_FAMILY";
const BASE_FONT_STRING = `${FONT_STYLE_REPLACEMENT_TOKEN} ${FONT_WEIGHT_REPLACEMENT_TOKEN} ${FONT_SIZE_REPLACEMENT_TOKEN}/${LINE_HEIGHT_REPLACEMENT_TOKEN} ${FONT_FAMILY_REPLACEMENT_TOKEN}`;
const _MeasureStyledText = class _MeasureStyledText extends TextMeasurer {
  constructor(el) {
    super();
    this.getTextWidth = ({
      text,
      fontStyle,
      fontWeight,
      fontSize,
      lineHeight,
      fontFamily
    }) => {
      const tokenReplacements = /* @__PURE__ */ new Map([
        [FONT_STYLE_REPLACEMENT_TOKEN, fontStyle || this.defaultFontStyle],
        [FONT_WEIGHT_REPLACEMENT_TOKEN, fontWeight || this.defaultFontWeight],
        [FONT_SIZE_REPLACEMENT_TOKEN, fontSize || this.defaultFontSize],
        [LINE_HEIGHT_REPLACEMENT_TOKEN, lineHeight || this.defaultLineHeight],
        [FONT_FAMILY_REPLACEMENT_TOKEN, fontFamily || this.defaultFontFamily]
      ]);
      this.ctx_.font = BASE_FONT_STRING.replace(
        new RegExp([...tokenReplacements.keys()].join("|"), "g"),
        (token) => tokenReplacements.get(token) || ""
      );
      return this.ctx_.measureText(text).width;
    };
    if (typeof window !== "undefined") {
      const computedStyle = window.getComputedStyle(el ?? document.body);
      this.defaultFontStyle = computedStyle.fontStyle || "normal";
      this.defaultFontWeight = computedStyle.fontWeight || "normal";
      this.defaultFontSize = computedStyle.fontSize || "10px";
      this.defaultLineHeight = computedStyle.lineHeight || "normal";
      this.defaultFontFamily = computedStyle.fontFamily || "sans-serif";
    }
  }
};
_MeasureStyledText.Instance = new _MeasureStyledText();
let MeasureStyledText = _MeasureStyledText;
const _MeasureStyledTextTag = class _MeasureStyledTextTag extends MeasureStyledText {
  static create(tagName) {
    if (!_MeasureStyledTextTag.instancesByTagName.has(tagName)) {
      _MeasureStyledTextTag.instancesByTagName.set(
        tagName,
        new _MeasureStyledTextTag(tagName)
      );
    }
    return _MeasureStyledTextTag.instancesByTagName.get(tagName);
  }
  constructor(tagName) {
    if (typeof window === "undefined") {
      super();
      return;
    }
    const el = document.createElement(tagName);
    document.body.appendChild(el);
    super(el);
    el.remove();
  }
};
_MeasureStyledTextTag.instancesByTagName = /* @__PURE__ */ new Map();
let MeasureStyledTextTag = _MeasureStyledTextTag;
const _MeasureStyledSvgText = class _MeasureStyledSvgText extends MeasureStyledText {
  constructor() {
    if (typeof window === "undefined") {
      super();
      return;
    }
    const el = createSvgElement("text");
    document.body.appendChild(el);
    super(el);
    el.remove();
  }
};
_MeasureStyledSvgText.Instance = new _MeasureStyledSvgText();
let MeasureStyledSvgText = _MeasureStyledSvgText;
export {
  MeasureStyledSvgText,
  MeasureStyledText,
  MeasureStyledTextTag,
  MeasureText,
  createSvgElement,
  getJoinedTspanText
};
//# sourceMappingURL=index.js.map
